import React, { useCallback, useMemo, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { useFormState } from 'react-hook-form'
import ModalBtns from '@groovehq/internal-design-system/lib/components/ModalBtns/ModalBtns'
import { AdminAccessDrawer } from 'subapps/settings/components/drawers/NoAccess'
import { useDrawer } from 'ducks/drawers/hooks'
import { buildDrawerQueryParam } from 'ducks/drawers/util'
import { doSaveChannelDraft, doClearChannelDraft } from 'ducks/channels/actions'
import { useConfirmHoldsCallback } from 'util/dirtyHolds'
import ChannelDetailsForm from '../../../../shared/forms/ChannelDetails'
import CONFIG from '../config'

const Actions = ({ formId, control, onClose }) => {
  const { isValid } = useFormState({ control })
  const handleBack = useCallback(
    () => {
      onClose({ ignoreStack: false })
    },
    [onClose]
  )

  return (
    <ModalBtns
      saveBtnText="Continue"
      saveBtnHtmlType="submit"
      saveBtnDisabled={!isValid}
      saveBtnForm={formId}
      tertiaryBtnText="Back"
      onClickTertiaryBtn={handleBack}
    />
  )
}

const ChannelDetails = ({
  onClose,
  onExit,
  drawerChannelType: channelType = 'forwarding',
  drawerResourceId: channelId,
  drawerId,
}) => {
  const dispatch = useDispatch()
  const { drawer, drawerTitle } = CONFIG[channelType]

  const { drawerId: nextDrawerId, openDrawer: openNextDrawer } = useDrawer(
    drawer
  )

  const formId = `${drawerId}-form`

  const handleOnClose = useConfirmHoldsCallback(formId, onClose, [onClose])

  const handleOnExit = useConfirmHoldsCallback(
    null,
    () => {
      dispatch(doClearChannelDraft(channelId))
      onExit()
    },
    [dispatch, onExit, channelId]
  )

  const onSubmit = useCallback(
    data => {
      dispatch(doSaveChannelDraft(channelId, data))
      openNextDrawer(channelId, {
        query: {
          ...buildDrawerQueryParam(
            nextDrawerId,
            'drawerChannelType',
            channelType
          ),
        },
      })
    },
    [dispatch, openNextDrawer, nextDrawerId, channelId, channelType]
  )

  const actionsComponentProps = useMemo(
    () => {
      return { formId, onClose: handleOnClose }
    },
    [formId, handleOnClose]
  )

  const footerRef = useRef(null)

  return (
    <AdminAccessDrawer
      title={drawerTitle}
      footer={<div ref={footerRef} />}
      onClose={handleOnExit}
    >
      <ChannelDetailsForm
        formId={formId}
        channelId={channelId}
        channelType={channelType}
        onSubmit={onSubmit}
        fullWidth
        actionsPortalRef={footerRef}
        actionsComponent={Actions}
        actionsComponentAdditionalProps={actionsComponentProps}
      />
    </AdminAccessDrawer>
  )
}

export default ChannelDetails
